import { AppImage } from '@components/appImage';
import Link from 'next/link';

import IconArrow from '@/assets/icons/iconArrow.svg';
import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesLongCardWithArrowInTitleProps {
  title: string;
  description: string;
  /** S3-путь картинки (не подписанный URL) — подписывает AppImage */
  image: string;
  href: string;
  className?: string;
}

export const CasesLongCardWithArrowInTitle = ({
  title,
  description,
  image,
  href,
  className,
}: CasesLongCardWithArrowInTitleProps) => {
  return (
    <Link
      href={href}
      target="_blank"
      className={classNames({
        cls: 'group mt-9 flex items-center rounded-[20px] px-6 py-4 max-sm:h-fit max-sm:flex-col max-sm:items-start max-sm:gap-4 max-sm:p-6',
        additional: [className],
      })}
      style={{
        background:
          'linear-gradient(90deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0048) 100%)',
      }}
    >
      <AppImage
        path={image}
        alt={title}
        width={109}
        height={109}
        className="h-[109px] w-[109px]"
      />

      <div className="ml-9 max-sm:ml-0">
        <div className="text-text-base-primary flex items-center gap-2 text-[18px] leading-[28px] font-medium">
          {title}
          <IconArrow className="text-text-base-primary h-[24px] w-[24px] rotate-[-45deg] transition-transform duration-300 group-hover:rotate-[0]" />
        </div>
        <p className="text-text-base-primary mt-3 text-[14px] leading-[20px] font-normal">
          {description}
        </p>
      </div>
    </Link>
  );
};
